import * as React from "react";
import "../../style/App.css";
import "./searchedProfile.css";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import ProfileInfo from "../profileTop/profileInfo";
import { getVal } from "react-redux-firebase";
import BubbleAnimation from "../HighFive/bubblejs";
import HighFive from "../HighFive/highfive";
import Badges from "../badges/badges";
import SupportPage from "../Support/SupportPage";
import QuitSmoking from "./quitSmoking";
import { searchProfile } from "../../store/actions/searchAction";
import CounterDetail from "../counterDetail/counterDetail";

import { getTotalChallenges } from "../../functions/getTotalChallenges";
import config from "../../firebase/config.json";
import { relative } from "path";
import firebase from "firebase/app";
import QuitDateSection from "../QuitDateSection/quitDateSection";
import moment from "moment";

export interface Props {
  id: any;
  searchedProfile: any;
  highfiveNo: number;
  badges: any;
  ownAuth: any;
  searchProfile(id): void;
  noProfile: any;
  totalChallenges: any;
  supporters: any;
  support_others: any;
  followForCounter: any;
  inApp: boolean;
  followedUsers: any;
  cookieStatus: boolean;
}
interface State {
  notPublic: boolean;
}
class SearchedProfile extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { notPublic: false };
  }

  componentDidMount() {
    console.log("CookiesAccepted: " + this.props.cookieStatus);
    this.props.searchProfile(this.props.id);
    if (this.props.cookieStatus) {
      firebase.analytics().logEvent("profile_opened", { uid: this.props.id });
    }
    fetch(
      "https://europe-west1-" +
      config.projectId +
      ".cloudfunctions.net/profileViews",
      {
        method: "POST",
        body: JSON.stringify({
          $uid: this.props.id,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      })
   
    setTimeout(() => {
      if (this.props.searchProfile) {
        this.setState({ notPublic: true });
      }
    }, 15000);
  }

  render() {
    const {
      searchedProfile,

      id,
      badges,
      totalChallenges,
    } = this.props;
    let { highfiveNo } = this.props;
    let stars_total = 0;
    let supporters = 0;
    let support_others = 0;
    if (!highfiveNo) {
      highfiveNo = 0;
    }

    if (searchedProfile) {
      stars_total = computeStarsWithDots(searchedProfile.stars_total);
      if (searchedProfile.amountFollower) {
        supporters = searchedProfile.amountFollower;
      }
      if (searchedProfile.amountFollowing) {
        support_others = searchedProfile.amountFollowing;
      }
    }

    let appStyle = {};

    if (this.props.inApp) {
      appStyle = {
        position: "relative",
        top: "-72px",
        paddingBottom: "70px",
      };
    }
    if (!searchedProfile) {
      return (
        <div style={{ minHeight: "100vh" }}>
          <div className="TOP_CONT" style={appStyle}>
            <ProfileInfo
              profile={searchedProfile}
              noProfile={this.state.notPublic}
            />
          </div>
          <div></div>
        </div>
      );
    }
    const dip = moment()
      .startOf("day")
      .diff(moment(this.props.searchedProfile.start_date).startOf("day"), "days");
    const ownProfile = this.props.ownAuth.uid === id;
    if (searchedProfile.supporterMode) {
      return (
        <div className="TOP_CONT" style={appStyle}>
          <ProfileInfo
            profile={searchedProfile}
            noProfile={this.props.noProfile}
          />
        </div>
      );
    }
    return (
      <div>
        <div className="TOP_CONT" style={appStyle}>
          <ProfileInfo
            profile={searchedProfile}
            noProfile={this.props.noProfile}
          />
          <CounterDetail
            profile={searchedProfile}
            stars={stars_total}
            highfiveNo={highfiveNo}
            badges={badges}
            total_challenges={totalChallenges}
            supporters={supporters}
            support_others={support_others}
            style={{ paddingBottom: this.props.inApp ? 50 : 0 }}
          />
          <QuitDateSection daysSinceStart={dip}></QuitDateSection>
          {!this.props.inApp && !ownProfile && (
            <SupportPage
              ownAuth={this.props.ownAuth}
              followProfile={searchedProfile}
              followId={id}
            />
          )}
        </div>
        {!this.props.inApp && <QuitSmoking />}
        <div style={appStyle}>
          {!ownProfile && (
            <div>
              <HighFive
                highfiveCurrent={highfiveNo}
                uid={id}
                profile={searchedProfile}
              />
              <BubbleAnimation />
            </div>
          )}
          {!this.props.inApp && !ownProfile && (
            <div className="SUPPORT_CONT_BACKGROUND">
              <SupportPage
                ownAuth={this.props.ownAuth}
                followProfile={searchedProfile}
                followId={id}
              />
            </div>
          )}
          <Badges
            style={{ paddingTop: this.props.inApp ? 50 : 0 }}
            badges={badges}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.match.params.number;
  return {
    cookieStatus: state.cookies.cookiesAccepted,
    id: ownProps.match.params.number,
    searchedProfile: getVal(state.firestore, `data/profile[${id}]`),
    highfiveNo: getVal(state.firestore, `data/highfives[${id}].number`),
    badges: getVal(state.firestore, `data/profile[${id}].badges`),
    followForCounter: getVal(state.firestore, `data/followForCounter[${id}]`),
    ownAuth: state.firebase.auth,
    noProfile: state.search.noProfile,
    totalChallenges: getTotalChallenges(state.firestore.ordered.challenges),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    searchProfile: (id) => dispatch(searchProfile(id)),
  };
};

export default compose<any>(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect((props) => [
    { collection: "profile", doc: props.id },
    { collection: "highfives", doc: props.id },
    { collection: "follow", doc: props.id, storeAs: "followForCounter" },
    {
      collection: "challenges",
      where: ["userids", "array-contains", props.id],
      storeAs: "challenges",
    },
  ])
)(SearchedProfile);

function computeStarsWithDots(stars) {
  if (stars) {
    return stars.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  } else return 0;
}



// WEBPACK FOOTER //
// ./src/components/screens/searchedProfile.tsx